import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { showToast } from '../../../services';
import { userActions } from '../../../actions';
import { profileActions } from '../../../actions';
import { useLoggedUser } from '../../../hooks/useLoggedUser';

import menuIcon from '../../../assets/img/menu-icon.svg';
import questionIcon from '../../../assets/img/question.svg';

const EditFavoriteActivities = () => {
    const [activities, setActivities] = useState([]);
    const [selectedActivities, setSelectedActivities] = useState([]);
    const dispatch = useDispatch();
    const history = useHistory();
    const loggedUser = useLoggedUser();

    // Fetch all activities when the component mounts
    useEffect(() => {
        if (loggedUser) {
            fetchFavActivities();
        }
    }, [dispatch, loggedUser]);

    // Fetch user profile and preselect activities
    useEffect(() => {
        if (loggedUser?.data?.StudentProfileID) {
            dispatch(profileActions.fetchMyprofile(loggedUser.data.StudentProfileID))
                .then((profile) => {
                    const favoriteActivities = Array.isArray(profile?.[0]?.FavoriteString)
                        ? profile[0].FavoriteString
                        : [];

                    setSelectedActivities(
                        favoriteActivities.map(fav => ({
                            ActivityID: fav.ActivityID,
                            ActivityName: fav.ActivityName
                        }))
                    );
                });
        }
    }, [dispatch, loggedUser?.data?.StudentProfileID]);

    // Fetch all available favorite activities
    const fetchFavActivities = () => {
        dispatch(userActions.fetchFavActivities())
            .then(response => {
                if (response) {
                    setActivities(response);
                } else {
                    setActivities([]);
                }
            })
            .catch(error => {
                showToast(error.toString(), 'error');
                setActivities([]);
            });
    };

    // Handle click to select/unselect activities
    const handleClick = (ActivityID, ActivityName) => {
        setSelectedActivities(prevSelectedActivities => {
            if (prevSelectedActivities.some(activity => activity.ActivityID === ActivityID)) {
                return prevSelectedActivities.filter(activity => activity.ActivityID !== ActivityID);
            } else {
                return [...prevSelectedActivities, { ActivityID, ActivityName }];
            }
        });
    };

    // Submit selected activities to the API
    const handleSubmit = (event) => {
        event.preventDefault();
        if (selectedActivities && selectedActivities.length > 0) {
            const formData = {
                StudentProfileID: loggedUser.data.StudentProfileID,
                FavoriteString: selectedActivities
            };

            dispatch(userActions.updatefavactivity(formData))
                .then(response => {
                    if (response) {
                        history.push('/myprofile');
                        showToast(response.responseMessage, 'success');
                    }
                })
                .catch(error => {
                    showToast(error.toString(), 'error');
                });
        } else {
            showToast('Please select at least one favourite activity.', 'warn');
        }
    };

    return (
        <React.Fragment>
            <div className="continer-fluid terms-page">
                <nav className="navbar navbar-expand-sm">
                    <div className="container-fluid">
                        <a className="navbar-brand">
                            <div className="w-20 d-flex align-items-center justify-content-center">
                                <img className="w-100" src={menuIcon} alt="Menu Icon" />
                            </div>
                        </a>
                        <div className="collapse navbar-collapse" id="mynavbar">
                            <ul className="navbar-nav me-auto"></ul>
                            <form className="d-flex justify-content-end">
                                <img className="w-100" src={questionIcon} alt="Question Icon" />
                            </form>
                        </div>
                    </div>
                </nav>

                <div className="content" id="content">
                    <div className="d-flex justify-content-center align-items-center flex-column">
                        <h2 className="b-font main-heading-top activities-h">What are your Favourite Activities</h2>
                        <div className="activity-cont">
                            <div className="row checkbox-div mb-5">
                                {activities && activities.length > 0 ? (
                                    activities
                                        .filter(activity => activity.EnabledFlag === "Y")
                                        .map((activity) => (
                                            <div key={activity.ActivityID} className="col-lg-4 col-md-4 col-sm-4 mb-4">
                                                <label className="checkbox-btn">
                                                    <input
                                                        type="checkbox"
                                                        onChange={() => handleClick(activity.ActivityID, activity.ActivityName)}
                                                        checked={selectedActivities.some(selected => selected.ActivityID === activity.ActivityID)}
                                                    />
                                                    <span></span> &nbsp;
                                                    {activity.ActivityName}
                                                </label>
                                            </div>
                                        ))
                                ) : (
                                    <div>No Activity available</div>
                                )}
                            </div>
                        </div>
                    </div>

                    <button className="accept-btn mt-2" type="submit" onClick={handleSubmit} style={{ marginLeft: '40%' }}>Update</button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EditFavoriteActivities;
